import StatisticsCounterTool from 'components/organisms/statistics-counter-tool/StatisticsCounterTool'
import React from 'react'

const CounterToolView = () => {
    return (
        <StatisticsCounterTool />
    )
}

export default CounterToolView